import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  searchByPageSync
} from "app/services/ServiceRequestItemService";
import { removeService, syncService } from "app/services/SyncCRMService";
export default class ServiceVoidedAsyncStore {
  searchRegisterService = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    departmentId: null,
    isSyncedToCRM: false,
    voided: true
  };
  resetSelectedRows = false;

  pageRegisterService = new PageResponse();
  selectServiceAsync = [];

  constructor() {
    makeAutoObservable(this);
  }

  pagingRegisterService = async () => {
    let { healthCareSvId, groupId, departmentId, ...ortherData } =
      this.searchRegisterService;
    if (healthCareSvId) {
      ortherData.healthCareSvId = healthCareSvId?.id;
    }
    if (groupId) {
      ortherData.groupId = groupId?.id;
    }
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    return await searchByPageSync({ ...ortherData, voided: true })
      .then(({ data }) => {
        this.pageRegisterService = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu tư vấn khách hàng có lỗi");
      });
  };

  handleChangeFormSearchService = (searchRegisterService) => {
    this.searchRegisterService = {
      ...this.searchRegisterService,
      ...searchRegisterService,
    };
    this.pagingRegisterService();
  };

  setSelectServiceAsync = (list) => {
    this.selectServiceAsync = list;
  };

  removeListServiceToCrm = async () => {
    const serviceIds = this.selectServiceAsync?.map((el) => el?.id) || [];
    this.resetSelectedRows = !this.resetSelectedRows;

    try {
      const { data } = await removeService(serviceIds);

      this.resetSelectedRows = !this.resetSelectedRows;
      this.selectServiceAsync = [];

      if (Array.isArray(data)) {
        const successCount = data.length;
        const total = serviceIds.length;

        if (successCount === total) {
          toast.success(`Đồng bộ dịch vụ thành công: ${successCount}/${total} bản ghi`);
        } else if (successCount > 0) {
          toast.warning(`Đồng bộ dịch vụ thành công một phần: ${successCount}/${total} bản ghi`);
        } else {
          toast.error("Đồng bộ dịch vụ thất bại");
        }

        this.pagingRegisterService();
        return data;
      } else {
        toast.error("Dữ liệu trả về từ API không hợp lệ");
        return [];
      }
    } catch (error) {
      this.resetSelectedRows = !this.resetSelectedRows;
      this.selectServiceAsync = [];
      console.error(error);
      toast.error("Đồng bộ dịch vụ có lỗi");
      return [];
    }
  };

  resetStore = () => {
    this.searchRegisterService = {
      ...new SearchObject(),
      fromLastDateSync: new Date(),
      toLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    };
    this.pageRegisterService = new PageResponse();
    this.selectServiceAsync = [];
  };
}
